import React from 'react';

// Import your image here, make sure to replace 'your-image-url' with the actual path or URL
const imageUrl = './assets/images/wait.png';

const Loading = () => {
  return (
    <div className="loading-container">
      <div className="loading"></div>
      <div className="loading-text">בטעינה...</div>
    </div>
  );
};

export default Loading;
